import React, { useEffect, useState } from 'react';
import { Button, Form, Input, Select, message, Popover, Tooltip } from 'antd';
import {
    RiAddFill,
    RiArrowLeftLine,
    RiFileList2Fill,
    RiSearch2Line,
} from 'react-icons/ri';
import { BsFillTerminalFill } from 'react-icons/bs';

// import "./CreateBuilds.css";
import TextArea from 'antd/es/input/TextArea';

import { workspaces_List_ActionHandler } from '../../../Redux/Actions/user/WorkspacesList';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { workspaces_FolderList_ActionHandler } from '../../../Redux/Actions/user/WorkspaceFolderList';
import {
    workspaces_SupportingDocumentsId_ActionHandler,
    workspaces_SupportingDocumentsId_Success,
} from '../../../Redux/Actions/user/workspacesSupportingDocumentsId';
import {
    workspaces_OutputFormatsId_ActionHandler,
    workspaces_OutputFormatsId_Success,
} from '../../../Redux/Actions/user/workspacesOutputFormatsId';
import { Supporting_Document_Delete_Success } from '../../../Redux/Actions/user/SupportingDocumentsDelete';
import { Supporting_Document_Output_Delete_Success } from '../../../Redux/Actions/user/SupportingOutputDocumentsDelete';
import { build_Action_Supporting_Document_Quick_Run_Success } from '../../../Redux/Actions/user/BuildQuickActionQuickSearch';
import { DocumentsSupportingCreateSuccess } from '../../../Redux/Actions/user/BuildQuickCreateSupportingDocumentsAction';
import { build_Quick_Action_ActionHandler } from '../../../Redux/Actions/user/BuildQuickAction';
import { DocumentsSupportingOutPutCreateSuccess } from '../../../Redux/Actions/user/BuildQuickOutputCreateSupportingDocumentsAction';
import {
    workspaces_Support_DocumentsList_Success,
    workspaces_Support_Documents_ActionHandler,
    workspaces_Support_Documents_OutputList_ActionHandler,
    workspaces_Supporting_Document_FolderList_Success,
} from '../../../Redux/Actions/user/WorkspaceSupportingDocumentList';
import BrowseSupprtingDocs from '../CreateBuilds/BrowseSupportingDocs/BrowseSupprtingDocs';
import BrowseOutputFormat from '../CreateBuilds/BrowseOutputFormat/BrowseOutputFormat';
import BulletBrowseOutputFormat from '../CreateBuilds/BulletBrowseOutputFormat/BulletBrowseOutputFormat';
import CreateSupportDocument from '../../Build/From/CreateSupportDocument/CreateSupportDocument';
import CreateOutputFormat from '../../Build/From/CreateOutputFormat/CreateOutputFormat';
import Loader from '../../../Components/Loader/Loader';
import {
    BuildQuickActionByIdActionHandler,
    BuildQuickActionByIdSuccess,
} from '../../../Redux/Actions/user/BuildQuickActionDetailsById';
import { useParams } from 'react-router-dom';
import { build_Quick_Action_Action_UpdateHandler } from '../../../Redux/Actions/user/BuildQuickActionUpdate';
const { Option } = Select;

const EditBuild = () => {
    //-------------------------------variable things--------------------------------------
    const Navigate = useNavigate();
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const parms = useParams();
    const BuildActionId = parms?.id;

    // ------------------------------------state things-----------------------------------
    const [browseSupportDocument, setBrowseSupportDocument] = useState(false);
    const [browseOutputFormat, setBrowseOutputFormat] = useState(false);
    const [isCreateSupportDocument, setIsCreateSupportDocument] =
        useState(false);
    const [isCreateOutputFormat, setIsCreateOutputFormat] = useState(false);
    const [browseOutputFormatBullet, setBrowseOutputFormatBullet] =
        useState(false);
    const [workspaceId, setWorkspaceId] = useState('');
    const [SupportingDocApiData, setSupportingDocApiData] = useState([]);
    const [OutputFormatApiData, setOutputFormatApiData] = useState([]);
    const [OutputFormatedeleteData, setOutputFormatedeleteData] =
        useState(false);
    const [onCreateSupportingDocument, setOnCreateSupportingDocument] =
        useState(null);
    const [onCreateOutputFormat, setonCreateOutputFormat] = useState(null);
    const [DocId, setDocId] = useState({
        docType: '',
        doc_id: '',
        search_query: '',
    });

    const [QuickActionName, setQuickActionName] = useState('');

    const [promptData, setPromptData] = useState('');
    const [workspaceFolderId, setworkspaceFolderId] = useState('');

    const [alreadyCheckSupporting, setAlreadyCheckSupporting] = useState([]);
    const [alreadyCheckOutput, setAlreadyCheckOutput] = useState([]);
    const [CommingOnDataApi, setCommingOnDataApi] = useState({
        Supporting_DocArr: [],
        Output_FormatArr: [],
    });

    const [RecentlyCreatedSupportdoc, setRecentlyCreatedSupportdoc] = useState(
        []
    );
    const [RecentlyCreatedOutputFormat, setRecentlyCreatedOutputFormat] =
        useState([]);
    // ------------------------------selector things-------------------------------------
    const workspaceData = useSelector(
        (state) => state?.workspaces_List_Data?.workspace_create_data?.data
    );

    const WorkspaceFolderListData = useSelector(
        (state) =>
            state?.workspaces_FolderList_Data?.workspace_folderList_data?.data
    );

    const getSupportingDocData = useSelector(
        (state) =>
            state?.workspacesSupportingDocumentsIdData
                ?.workspace_supportingdocumentid_data
    );

    const getOutputFormatData = useSelector(
        (state) =>
            state?.workspacesOutputFormatsIdData
                ?.workspace_output_formateid_data
    );

    const supportingdocumentdeleteData = useSelector(
        (state) =>
            state?.SupportingOutputDocumentDeletedata
                ?.Supporting_document_delete_data
    );

    const QuickSearchData = useSelector(
        (state) =>
            state?.build_Action_Supporting_Document_Quick_Run_Data
                ?.build_action_supporting_document_quick_run_data
    );

    const supportinDocumentCreate = useSelector(
        (state) =>
            state?.BuildQuickCreateSupportingDocumentsData
                ?.documents_supporting_create_data
    );

    const OutputformatDocumentCreate = useSelector(
        (state) =>
            state?.BuildQuickOutputCreateSupportingDocumentsData
                ?.documents_supporting_output_create_data
    );

    const OnSupportingFolderListData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderList_Data
                ?.workspace_supporting_documentlist_data?.data
    );

    const OnOutputFolderListData = useSelector(
        (state) =>
            state?.workspaces_Supporting_Document_FolderList_Data
                ?.workspace_supporting_document_folderList_data?.data
    );

    const buildQuickActionEditData = useSelector(
        (state) =>
            state?.build_Quick_Action_By_Id_data?.build_quick_action_by_id__data
                ?.data
    );

    const buildQuickActionEditDataLoader = useSelector(
        (state) => state?.build_Quick_Action_By_Id_data?.loader
    );

    //get Edit Initial data------------------------------------
    useEffect(() => {
        if (buildQuickActionEditData) {
            const newInitialValues = {
                workspaceId: buildQuickActionEditData?.folder?.workspace_id,
                folder_id: buildQuickActionEditData?.folder_id,
                QuickActionName: buildQuickActionEditData?.name,
                prompt: buildQuickActionEditData?.prompt,
                output_format_ids: '',

                supporting_documents: '',
            };

            form.setFieldsValue(newInitialValues);
            setQuickActionName(buildQuickActionEditData?.name);
            setWorkspaceId(buildQuickActionEditData?.folder?.workspace_id);
            setPromptData(buildQuickActionEditData?.prompt);
            setworkspaceFolderId(buildQuickActionEditData?.folder_id);

            const supportingDocArray =
                buildQuickActionEditData?.supporting_documents.map(
                    (item) => item?.supporting_document
                );

            const OutputFormatArrays =
                buildQuickActionEditData?.output_formats.map(
                    (item) => item?.output_format
                );

            setCommingOnDataApi((prevData) => ({
                ...prevData,
                Supporting_DocArr: supportingDocArray,
                Output_FormatArr: OutputFormatArrays,
            }));

            //toaken all id for delete
            const supportingDocIdsO = supportingDocArray?.map(
                (item) => item.id
            );
            setAlreadyCheckSupporting((prevIds) => [
                ...new Set([...prevIds, ...supportingDocIdsO]),
            ]);

            const OutputForIds = OutputFormatArrays?.map((item) => item?.id);
            setAlreadyCheckOutput((prevIds) => [
                ...new Set([...prevIds, ...OutputForIds]),
            ]);

            setTimeout(() => {
                setCommingOnDataApi({
                    Supporting_DocArr: [],
                    Output_FormatArr: [],
                });
            }, 8000);
        }
    }, [buildQuickActionEditData, form]);

    // ------------------------------useEffct things-------------------------------------

    useEffect(() => {
        dispatch(BuildQuickActionByIdActionHandler(BuildActionId));
        // eslint-disable-next-line
    }, [BuildActionId]);

    useEffect(() => {
        dispatch(workspaces_List_ActionHandler('', ''));

        return () => {
            dispatch(workspaces_SupportingDocumentsId_Success(null));
            dispatch(workspaces_OutputFormatsId_Success(null));
            dispatch(workspaces_Supporting_Document_FolderList_Success(null));
            dispatch(workspaces_Support_DocumentsList_Success(null));
            setAlreadyCheckSupporting([]);
            setAlreadyCheckOutput([]);
            setRecentlyCreatedSupportdoc([]);
            setRecentlyCreatedOutputFormat([]);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (workspaceId) {
            dispatch(workspaces_FolderList_ActionHandler(workspaceId, '', ''));

            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(workspaceId, '')
            );
            dispatch(workspaces_OutputFormatsId_ActionHandler(workspaceId, ''));

            // drawer folder
            dispatch(
                workspaces_Support_Documents_OutputList_ActionHandler(
                    workspaceId,
                    '',
                    ''
                )
            );
            dispatch(
                workspaces_Support_Documents_ActionHandler(workspaceId, '', '')
            );
        }
        // eslint-disable-next-line
    }, [workspaceId]);

    const alreaycheckedS = (id) => {
        if (CommingOnDataApi?.Supporting_DocArr?.length) {
            return CommingOnDataApi.Supporting_DocArr?.some(
                (item) => item?.id === id
            );
        }

        if (alreadyCheckSupporting?.length)
            return alreadyCheckSupporting?.includes(id);
    };

    useEffect(() => {
        if (getSupportingDocData?.data) {
            const sortedData = getSupportingDocData?.data?.data
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((item) => ({
                    ...item,
                    isCheck: alreaycheckedS(item?.id),
                    is_qs: false,
                }));
            setSupportingDocApiData(sortedData);
        }

        // eslint-disable-next-line
    }, [getSupportingDocData?.data]);

    const filterFolderSupport = (value) => {
        if (value === '') {
            const sortedData = getSupportingDocData?.data?.data
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((item) => ({
                    ...item,
                    isCheck: alreaycheckedS(item?.id),
                    is_qs: false,
                }));
            setSupportingDocApiData(sortedData);
        } else {
            const filteredData = getSupportingDocData?.data?.data
                ?.filter((item) => item?.folder === value)
                ?.map((item) => ({
                    ...item,
                    isCheck: alreaycheckedS(item?.id),
                    is_qs: false,
                }));

            setSupportingDocApiData(filteredData);
        }
    };

    const alreaycheckedOt = (id) => {
        if (CommingOnDataApi?.Output_FormatArr?.length) {
            return CommingOnDataApi.Output_FormatArr?.some(
                (item) => item?.id === id
            );
        }

        if (alreadyCheckOutput?.length) return alreadyCheckOutput?.includes(id);
    };
    useEffect(() => {
        if (getOutputFormatData?.data) {
            const sortedData = getOutputFormatData?.data?.data
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((item) => ({
                    ...item,
                    isCheck: alreaycheckedOt(item?.id),
                }));
            setOutputFormatApiData(sortedData);
        }
        // eslint-disable-next-line
    }, [getOutputFormatData?.data]);

    const filterFolderOutput = (value) => {
        if (value === '') {
            const sortedData = getOutputFormatData?.data?.data
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((item) => ({
                    ...item,
                    isCheck: alreaycheckedOt(item?.id),
                }));
            setOutputFormatApiData(sortedData);
        } else {
            const filteredData = getOutputFormatData?.data?.data
                ?.filter((item) => item?.folder === value)
                ?.map((item) => ({
                    ...item,
                    isCheck: alreaycheckedS(item?.id),
                    is_qs: false,
                }));
            setOutputFormatApiData(filteredData);
        }
    };

    useEffect(() => {
        if (supportingdocumentdeleteData?.message) {
            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(workspaceId, '')
            );
            dispatch(Supporting_Document_Delete_Success(null));
        }
    }, [supportingdocumentdeleteData?.message]);

    useEffect(() => {
        if (OutputFormatedeleteData) {
            setTimeout(() => {
                dispatch(
                    workspaces_OutputFormatsId_ActionHandler(workspaceId, '')
                );
                dispatch(Supporting_Document_Output_Delete_Success(null));
                setOutputFormatedeleteData(false);
            }, 1000);
        }
    }, [OutputFormatedeleteData]);

    useEffect(() => {
        if (supportinDocumentCreate?.data) {
            setOnCreateSupportingDocument(supportinDocumentCreate?.data);
            dispatch(
                workspaces_SupportingDocumentsId_ActionHandler(workspaceId, '')
            );

            //open browse from libray
            setTimeout(() => {
                BrowseSuppDocsOverlay(true);
            }, 1500);
        }
    }, [supportinDocumentCreate?.data]);

    useEffect(() => {
        if (SupportingDocApiData?.length && supportinDocumentCreate?.data) {
            setTimeout(() => {
                const filteredData = SupportingDocApiData?.find(
                    (item) => item?.id === onCreateSupportingDocument?.id
                );

                if (filteredData) {
                    if (!filteredData?.can_select) {
                        dispatch(
                            workspaces_SupportingDocumentsId_ActionHandler(
                                workspaceId,
                                ''
                            )
                        );
                    } else if (filteredData?.can_select) {
                        const updatedData = SupportingDocApiData?.map(
                            (item) => {
                                if (item?.id === filteredData?.id) {
                                    return { ...item, isCheck: true };
                                }
                                return item;
                            }
                        );
                        setSupportingDocApiData(updatedData);
                        setTimeout(() => {
                            dispatch(DocumentsSupportingCreateSuccess(null));
                        }, 1500);

                        //Taken for alreday check data--------------------
                        setAlreadyCheckSupporting((prevData) => {
                            if (
                                !prevData.includes(
                                    onCreateSupportingDocument.id
                                )
                            ) {
                                return [
                                    ...prevData,
                                    onCreateSupportingDocument.id,
                                ];
                            }
                            return prevData;
                        });

                        setRecentlyCreatedSupportdoc((prevData) => {
                            if (
                                !prevData?.includes(
                                    onCreateSupportingDocument.id
                                )
                            ) {
                                return [
                                    ...prevData,
                                    onCreateSupportingDocument.id,
                                ];
                            }
                            return prevData;
                        });
                    }
                }
            }, 1500);
        }
    }, [SupportingDocApiData]);

    useEffect(() => {
        if (OutputformatDocumentCreate?.data) {
            setonCreateOutputFormat(OutputformatDocumentCreate?.data);
            dispatch(workspaces_OutputFormatsId_ActionHandler(workspaceId, ''));

            //open browse from libray
            setTimeout(() => {
                BrowseOutputFormatOverlay();
            }, 1500);
        }
    }, [OutputformatDocumentCreate?.data]);

    useEffect(() => {
        if (onCreateOutputFormat?.id && OutputFormatApiData.length) {
            const updatedData = OutputFormatApiData?.map((item) => {
                if (item?.id === onCreateOutputFormat?.id) {
                    return { ...item, isCheck: true };
                }
                return item;
            });

            setOutputFormatApiData(updatedData);

            setTimeout(() => {
                dispatch(DocumentsSupportingOutPutCreateSuccess(null));
                setonCreateOutputFormat(null);
            }, 2000);

            setAlreadyCheckOutput((prevData) => {
                if (!prevData.includes(onCreateOutputFormat?.id)) {
                    return [...prevData, onCreateOutputFormat?.id];
                }
                return prevData;
            });

            setRecentlyCreatedOutputFormat((prevData) => {
                if (!prevData.includes(onCreateOutputFormat?.id)) {
                    return [...prevData, onCreateOutputFormat?.id];
                }
                return prevData;
            });
        }
    }, [onCreateOutputFormat, OutputFormatApiData]);

    useEffect(() => {
        if (QuickSearchData?.data) {
            if (DocId?.docType === 'support_document') {
                setSupportingDocApiData((prevData) => {
                    return prevData?.map((item) => {
                        if (item?.id === DocId?.doc_id) {
                            return {
                                ...item,
                                is_qs: true,
                                is_searched_now: true,
                                rerun_on_data_update: true,
                                relevance_score: QuickSearchData?.data?.score,
                                search_query: DocId?.search_query,
                                search_result:
                                    QuickSearchData?.data?.search_result,
                                search_type: 'context',
                            };
                        }
                        return item;
                    });
                });
            }

            if (DocId?.docType === 'output_format') {
                setOutputFormatApiData((prevData) => {
                    return prevData?.map((item) => {
                        if (item?.id === DocId?.doc_id) {
                            return {
                                ...item,
                                is_qs: true,
                                is_searched_now: true,
                                rerun_on_data_update: true,
                                relevance_score: QuickSearchData?.data?.score,
                                search_query: DocId?.search_query,
                                search_result:
                                    QuickSearchData?.data?.search_result,
                                search_type: 'context',
                            };
                        }
                        return item;
                    });
                });
            }

            setTimeout(() => {
                dispatch(
                    build_Action_Supporting_Document_Quick_Run_Success(null)
                );
            }, 3500);
        }
    }, [QuickSearchData?.data]);

    // ------------------------------function things-------------------------------------

    const BrowseSuppDocsOverlay = () => {
        setBrowseSupportDocument(!browseSupportDocument);
    };

    const BrowseOutputFormatOverlay = () => {
        setBrowseOutputFormat(!browseOutputFormat);
    };

    const BrowseOutputFormat_BulletOverlay = () => {
        setBrowseOutputFormatBullet(!browseOutputFormatBullet);
    };

    const CreateSuppDocumentOverlay = () => {
        if (workspaceId) {
            setIsCreateSupportDocument(!isCreateSupportDocument);
        }
    };

    const CreateOutputFormatOverlay = () => {
        if (workspaceId) {
            setIsCreateOutputFormat(!isCreateOutputFormat);
        }
    };

    const handleChangeWorkspace = (value) => {
        setWorkspaceId(value);
        setworkspaceFolderId('');
    };

    const handleQuickSubmit = () => {
        if (
            !QuickActionName ||
            !promptData ||
            !workspaceId ||
            !workspaceFolderId
        ) {
            message.error('Please fill in all required fields');
            return;
        }
        const OutputcheckedIds = OutputFormatApiData?.filter(
            (item) => item?.isCheck
        ).map((item) => item?.id);

        let request = {
            workspace_id: workspaceId,
            folder_id: workspaceFolderId,
            name: QuickActionName,
            prompt: promptData,
            supporting_documents: SupportingDocApiData?.filter(
                (item) => item?.isCheck
            ),
            output_format_ids: OutputcheckedIds,
        };

        dispatch(
            build_Quick_Action_Action_UpdateHandler(
                request,
                BuildActionId,
                Navigate
            )
        );
    };

    return (
        <>
            {buildQuickActionEditDataLoader && <Loader />}
            <Form form={form}>
                <div className='from-container'>
                    <div className='from-main_1'>
                        <div className='from-build-main'>
                            <h2>Edit Build QuickAction</h2>
                            <p
                                className='form-p form-w from-pointer form-flex form-justify-content form-align-items'
                                onClick={() => Navigate(-1)}>
                                <RiArrowLeftLine /> Back
                            </p>
                        </div>
                        <p style={{ margin: '0 0 20px 0' }}>
                            Craft your QuickAction manually by filling out below
                            details
                        </p>
                        {/* Quickaction name */}
                        <div className='from-basic-main'>
                            <img
                                src={'/images/edit_icon-build.svg'}
                                className='form-sideIcon-size'
                                alt=''
                            />
                            <p className='form-p form-w form-ml-5'>
                                {' '}
                                Basic Information
                            </p>
                        </div>
                        <p className='form-label new-build-label'>
                            QuickAction Name{' '}
                            <span style={{ color: 'red' }}>*</span>
                        </p>
                        <Form.Item
                            name='QuickActionName'
                            initialValue={QuickActionName}
                            rules={[
                                {
                                    required: true,
                                    message:
                                        'Please input your QuickAction Name!',
                                },
                            ]}>
                            <Input
                                placeholder='Enter your QuickAction Name'
                                onChange={(e) =>
                                    setQuickActionName(e.target.value)
                                }
                            />
                        </Form.Item>
                        {/* Quickaction name */}
                    </div>
                    {/* workspace and folder name */}
                    <div>
                        <div className='from-basic-main'>
                            <img
                                src={'/images/folder-open.svg'}
                                className='form-sideIcon-size'
                                alt=''
                            />
                            <p className='form-p form-w form-ml-5'>
                                {' '}
                                Select Destination Directory
                            </p>
                        </div>
                        <div className='select-workspace-folder'>
                            <div>
                                <p className='form-label new-build-label'>
                                    Select Workspace{' '}
                                    <span style={{ color: 'red' }}>*</span>
                                </p>
                                <Form.Item
                                    name='workspaceId'
                                    initialValue={workspaceId}
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Please input your QuickAction Name!',
                                        },
                                    ]}>
                                    <Select
                                        className=''
                                        onChange={handleChangeWorkspace}
                                        placeholder='Select workspace'>
                                        {workspaceData &&
                                            workspaceData
                                                ?.filter(
                                                    (workspace) =>
                                                        !workspace.is_locked
                                                )
                                                ?.map((workspace) => (
                                                    <Option
                                                        key={workspace?.id}
                                                        value={workspace?.id}>
                                                        {workspace?.name}
                                                    </Option>
                                                ))}
                                    </Select>
                                </Form.Item>
                            </div>

                            <div>
                                <p className='form-label new-build-label'>
                                    Select Folder{' '}
                                    <span style={{ color: 'red' }}>*</span>
                                </p>
                                <Form.Item
                                    name='folder_id'
                                    initialValue={workspaceFolderId}
                                    rules={[
                                        {
                                            required: true,
                                            message:
                                                'Please input your QuickAction Name!',
                                        },
                                    ]}>
                                    <Select
                                        className=''
                                        name='folder_id'
                                        onChange={(value) =>
                                            setworkspaceFolderId(value)
                                        }
                                        placeholder='Select folder'>
                                        {WorkspaceFolderListData &&
                                            WorkspaceFolderListData?.map(
                                                (folder) => (
                                                    <Option
                                                        key={folder?.id}
                                                        value={folder?.id}>
                                                        {folder.name}
                                                    </Option>
                                                )
                                            )}
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                    {/* workspace and folder name */}

                    {/* {select document} */}
                    {/* <div className="from-basic-main">
            <RiFileList2Fill className="form-sideIcon-size" />
            <p className="form-p form-w form-ml-5"> Reference data</p>
          </div> */}
                    <div>
                        <p className='form-p form-w'>Supporting Documents</p>
                        <p className='form-label new-build-label'>
                            This data will support and inform the output of your
                            QuickAction.
                        </p>
                    </div>
                    <div className='new-build-flex'>
                        <Tooltip
                            placement='top'
                            title={
                                !workspaceId && 'Please select the workspace'
                            }
                            overlayStyle={{ maxWidth: '900px' }}
                            trigger={'click'}>
                            <div
                                className='form-flex new-build-supporting'
                                onClick={CreateSuppDocumentOverlay}>
                                <div className='form-text edit-text'>
                                    Create New Document
                                </div>
                                <div className='form-text'>
                                    <RiAddFill className='form-sideIcon-size' />
                                </div>
                            </div>
                        </Tooltip>

                        <div
                            className='form-flex new-build-supporting'
                            onClick={BrowseSuppDocsOverlay}>
                            <div className='form-text edit-text'>
                                Browse from Library
                            </div>
                            <div className='form-text'>
                                <RiAddFill className='form-sideIcon-size' />
                            </div>
                        </div>
                    </div>

                    <div>
                        <p className='form-p form-w'>Output Format</p>
                        <p className='form-label new-build-label'>
                            This represents your desired output format, ensuring
                            output consistency.
                        </p>
                    </div>
                    <div className='new-build-flex'>
                        <Tooltip
                            placement='top'
                            title={
                                !workspaceId && 'Please select the workspace'
                            }
                            overlayStyle={{ maxWidth: '900px' }}
                            trigger={'click'}>
                            <div
                                className='form-flex new-build-supporting'
                                onClick={CreateOutputFormatOverlay}>
                                <div className='form-text edit-text'>
                                    Create Output Format
                                </div>
                                <div className='form-text'>
                                    <RiAddFill className='form-sideIcon-size' />
                                </div>
                            </div>
                        </Tooltip>

                        <div
                            className='form-flex new-build-supporting'
                            onClick={BrowseOutputFormatOverlay}>
                            <div className='form-text edit-text'>
                                Browse from Library
                            </div>
                            <div className='form-text'>
                                <RiAddFill className='form-sideIcon-size' />
                            </div>
                        </div>
                    </div>

                    {/* {select document} */}

                    {/* prompt */}
                    <div className='form-mb-24'>
                        <div className='from-main_1'>
                            <div className='form-main-sub-title'>
                                <BsFillTerminalFill className='form-sideIcon-size' />
                                <p className='form-p form-w form-ml-5'>
                                    QuickAction Prompt
                                </p>
                            </div>
                            <div className=''>
                                <p className='form-label new-build-label'>
                                    Compose your QuickAction here.
                                </p>
                                <TextArea
                                    rows='4'
                                    placeholder='Write your prompt...'
                                    value={promptData}
                                    onChange={(e) =>
                                        setPromptData(e.target.value)
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    {/* prompt */}

                    <div
                        className='form-action-button'
                        onClick={handleQuickSubmit}>
                        <Button className='main-form-button'>Save</Button>
                    </div>
                </div>
            </Form>

            {browseSupportDocument && (
                <BrowseSupprtingDocs
                    open_Drawer={BrowseSuppDocsOverlay}
                    browseSupportDocument={browseSupportDocument}
                    SupportingDocApiData={SupportingDocApiData}
                    setSupportingDocApiData={setSupportingDocApiData}
                    workspaceId={workspaceId}
                    DocId={DocId}
                    setDocId={setDocId}
                    RecentlyCreatedSupportdoc={RecentlyCreatedSupportdoc}
                    setAlreadyCheckSupporting={setAlreadyCheckSupporting}
                    OnSupportingFolderListData={OnSupportingFolderListData}
                    filterFolderSupport={filterFolderSupport}
                />
            )}
            {browseOutputFormat && (
                <BrowseOutputFormat
                    open_Drawer={BrowseOutputFormatOverlay}
                    BrowseOutputFormat={browseOutputFormat}
                    OutputFormatApiData={OutputFormatApiData}
                    setOutputFormatApiData={setOutputFormatApiData}
                    workspaceId={workspaceId}
                    setOutputFormatedeleteData={setOutputFormatedeleteData}
                    DocId={DocId}
                    setDocId={setDocId}
                    RecentlyCreatedOutputFormat={RecentlyCreatedOutputFormat}
                    setAlreadyCheckOutput={setAlreadyCheckOutput}
                    OnOutputFolderListData={OnOutputFolderListData}
                    filterFolderOutput={filterFolderOutput}
                />
            )}

            {browseOutputFormatBullet && (
                <BulletBrowseOutputFormat
                    open_Drawer={BrowseOutputFormat_BulletOverlay}
                    browseOutputFormatBullet={browseOutputFormatBullet}
                />
            )}

            {isCreateSupportDocument ? (
                <CreateSupportDocument
                    isCreateSupportDocument={isCreateSupportDocument}
                    handleCreateSupportDocument={CreateSuppDocumentOverlay}
                    workspaceId={workspaceId}

                    // workspaceFolderFlag={false}
                    // workspaceFolderId={workspaceFolderId}
                    // workspaceByIdStatus={workspaceById}
                    // folderByIdStatus={folderById}
                />
            ) : null}
            {isCreateOutputFormat ? (
                <CreateOutputFormat
                    isCreateOutputFormat={isCreateOutputFormat}
                    handleCreateOutputFormat={CreateOutputFormatOverlay}
                    workspaceId={workspaceId}
                    // workspaceFolderId={workspaceFolderId}
                    // workspaceByIdStatus={workspaceById}
                    // folderByIdStatus={folderById}
                />
            ) : null}
        </>
    );
};

export default EditBuild;
